import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const MetabolismIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" {...rest}>
      <g
        id="Symbols-Metabolism"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Metabolism" stroke={color} strokeWidth="3">
          <g id="Group" transform="translate(1.729000, 5.187000)">
            <polyline points="9.6824 25.5282031 9.6824 35.1050474 0 35.1050474" />
            <polyline points="38.7296 15.9513588 38.7296 6.37451441 48.412 6.37451441" />
            <path d="M39.3363637,6.36812985 C46.2180842,13.4594735 47.1265679,24.3532175 41.5126319,32.4640391 C35.898696,40.5748608 25.3021783,43.6780553 16.1287268,39.897726" />
            <path d="M9.07348462,35.111432 C2.20705486,28.016881 1.30772086,17.1333141 6.91832574,9.03011437 C12.5289306,0.926914583 23.1135608,-2.17765202 32.2832732,1.59034862" />
            <path d="M17.7410433,20.6728262 C17.7410433,24.4924275 20.837442,27.5888262 24.6570434,27.5888262 C28.4766448,27.5888262 31.5730435,24.4924275 31.5730435,20.6728262 C31.5730435,16.8532248 28.4766448,13.7568262 24.6570434,13.7568262 C20.837442,13.7568262 17.7410433,16.8532248 17.7410433,20.6728262 Z" />
            <path d="M17.7410433,15.4858262 C17.7410433,16.4407265 18.515143,17.2148262 19.4700433,17.2148262 C20.4249436,17.2148262 21.1990433,16.4407265 21.1990433,15.4858262 C21.1990433,14.5309258 20.4249436,13.7568262 19.4700433,13.7568262 C18.515143,13.7568262 17.7410433,14.5309258 17.7410433,15.4858262 Z" />
            <path d="M31.5730433,22.4018262 C31.5730433,23.3567265 32.347143,24.1308262 33.3020433,24.1308262 C34.2569436,24.1308262 35.0310433,23.3567265 35.0310433,22.4018262 C35.0310433,21.4469258 34.2569436,20.6728262 33.3020433,20.6728262 C32.347143,20.6728262 31.5730433,21.4469258 31.5730433,22.4018262 Z" />
            <path d="M19.4700433,27.5888262 C19.4700433,28.5437265 20.244143,29.3178262 21.1990433,29.3178262 C22.1539436,29.3178262 22.9280433,28.5437265 22.9280433,27.5888262 C22.9280433,26.6339258 22.1539436,25.8598262 21.1990433,25.8598262 C20.244143,25.8598262 19.4700433,26.6339258 19.4700433,27.5888262 Z" />
          </g>
        </g>
      </g>
    </svg>
  );
};
